import React, {useEffect} from 'react'
import {Icon, withModal, Button, RadioGroup} from '@thryvlabs/maverick'
import dayjs from 'dayjs'
import Calendar from 'react-calendar'
import {ModalContent} from '../ui/new-demo'
import {AddonsDatePickerContainer} from '../ui/addons-datepicker-container'

const RADIO_OPTIONS = [
  {
    name: 'No',
    value: false,
  },
  {
    name: 'Yes',
    value: true,
  },
]

function AddOnsDatePickerModal({
  setSelectedDate = () => {},
  billingDate,
  itemName,
  maxDate = 33,
  overrideOnClick,
  useOverrideUseEffect,
}) {
  const [showModalButton, setShowModalButton] = React.useState(false)
  const [placeHolder, setPlaceHolder] = React.useState('Billing Start Date')

  React.useEffect(() => {
    if (!billingDate) {
      setShowModalButton(false)
      setPlaceHolder('Billing Start Date')
      return
    }
    const parsedDate = dayjs(billingDate)
    if (parsedDate.isValid()) {
      setShowModalButton(true)
      setPlaceHolder(parsedDate.format('MM/DD/YYYY'))
    }
  }, [billingDate])
  const getMinDate = () => {
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    return tomorrow
  }

  const getMaxDate = () => {
    let defaultMaxDate = new Date()
    defaultMaxDate.setDate(defaultMaxDate.getDate() + maxDate)
    return defaultMaxDate
  }

  const onSelectedDay = (selectedCalendarDay, close) => {
    // Use local date components to avoid timezone bugs: when user picks "March 7",
    // we must send "2026-03-07" not "2026-03-06". The previous format "YYYY-MM-DD hh:mm:ss"
    // was ambiguous (12hr) and parsed inconsistently on the backend, causing "today"
    // to become "yesterday" for users west of UTC. Date-only "YYYY-MM-DD" is
    // unambiguous; backend normalizes to UTC start-of-day for Recurly.
    const localDate = new Date(
      selectedCalendarDay.getFullYear(),
      selectedCalendarDay.getMonth(),
      selectedCalendarDay.getDate(),
    )
    const dateOnly = dayjs(localDate).format('YYYY-MM-DD')
    setSelectedDate(dateOnly)
    setPlaceHolder(dayjs(localDate).format('MM/DD/YYYY'))
    close()
  }

  const handleIncludeDate = e => {
    setShowModalButton(e.value)
    if (!e.value) {
      setSelectedDate(null)
      setPlaceHolder('Billing Start Date')
    }
  }

  const clear = close => {
    setSelectedDate(null)
    setPlaceHolder('Billing Start Date')
    close()
  }

  const tomorrow = close => {
    // Recurly rejects "today" as a future start date; minimum is tomorrow.
    const tomorrowDate = new Date()
    tomorrowDate.setDate(tomorrowDate.getDate() + 1)
    const localDate = new Date(
      tomorrowDate.getFullYear(),
      tomorrowDate.getMonth(),
      tomorrowDate.getDate(),
    )
    const dateOnly = dayjs(localDate).format('YYYY-MM-DD')
    setSelectedDate(dateOnly)
    setPlaceHolder(dayjs(localDate).format('MM/DD/YYYY'))
    close()
  }

  useEffect(() => {
    if (!useOverrideUseEffect) return undefined
    if (overrideOnClick) {
      setSelectedDate(null)
      if (showModalButton) {
        overrideOnClick()
        setShowModalButton(false)
      }
    }
  }, [overrideOnClick, showModalButton, useOverrideUseEffect])

  const Modal = ({close}) => (
    <ModalContent>
      <AddonsDatePickerContainer>
        <div>
          <div className="calendar">
            <Calendar
              style={{marginBottom: '0px'}}
              minDate={getMinDate()}
              maxDate={getMaxDate()}
              defaultValue={getMinDate()}
              calendarType="US"
              next2Label={null}
              prev2Label={null}
              nextLabel={
                <Icon type="solid" variant="arrowRight" className="m-auto" />
              }
              prevLabel={
                <Icon type="solid" variant="arrowLeft" className="m-auto" />
              }
              tileClassName="calendar-tile"
              onClickDay={e => onSelectedDay(e, close)}
            />
          </div>
        </div>
        <div className="d-flex justify-content-between mt-3">
          <Button variant="secondary" onClick={() => tomorrow(close)}>
            Tomorrow
          </Button>
          <Button variant="secondary" onClick={() => clear(close)}>
            Clear
          </Button>
          <Button variant="secondary" onClick={close}>
            Close
          </Button>
        </div>
      </AddonsDatePickerContainer>
    </ModalContent>
  )

  const DateInput = ({showModal}) => (
    <Button
      style={{
        backgroundColor: overrideOnClick ? '#cccccc' : undefined,
      }}
      variant={placeHolder === 'Billing Start Date' ? 'primary' : 'secondary'}
      onClick={() => {
        if (overrideOnClick) {
          overrideOnClick()
          setSelectedDate(null)
          setShowModalButton(false)
        } else {
          showModal()
        }
      }}
    >
      {placeHolder}
    </Button>
  )

  const DateModal = withModal(DateInput, Modal)
  return (
    <div className="d-flex align-items-center">
      <div onClick={overrideOnClick} className="row ml-3 ">
        <RadioGroup
          disabled={!!overrideOnClick}
          data={RADIO_OPTIONS}
          value={showModalButton ? RADIO_OPTIONS[1] : RADIO_OPTIONS[0]}
          row
          onChange={handleIncludeDate}
          layoutStyles={{
            position: 'relative',
            top: '-18px',
            gap: '10px',
          }}
        />
      </div>
      <div className="ml-5">{showModalButton && <DateModal />}</div>
    </div>
  )
}

export {AddOnsDatePickerModal}
